const InsuranceChallenge1Dataset = {
    
        items: {
           
            "item-1": { id: "item-1", content: "A fire in your kitchen destroys your microwave and cabinets. ", 
                    answer: "column-3" },
            "item-2": { id: "item-2", content: "You buy a new phone and drop it the next day, cracking the screen.", 
                    answer: "column-5"},
            "item-3": { id: "item-3", content: "A deer runs into the side of your car on a country road.", 
                    answer: "column-2" },
            "item-4": { id: "item-4", content: "You live in an apartment and the exterior of the building is damaged " +
                        "by a hail storm.",
                    answer: "column-5" },
            "item-5": { id: "item-5", content: "Someone steals your bicycle out of your garage",
                    answer: "column-3" },
            "item-6": { id: "item-6", content: "You have been having difficulty walking without a limp and " +
                    "you've decided to see a knee doctor.",
                    answer: "column-4" },
            "item-7": { id: "item-7", content: "You get a speeding ticket. ",
                    answer: "column-5"},
            "item-8": { id: "item-8", content: "Your car was parked in your driveway and someone broke out the " +
                    "back window.",
                    answer: "column-2"},
            "item-9": { id: "item-9", content: "A storm blows a tree onto the roof of your home.", 
                    answer: "column-3"},
            "item-10": {id: "item-10", content: "You go to the doctor for a yearly check-in.",
                    answer: "column-4"}   
        },
        columns: {
            "column-1": { id: "column-1", title: "Situations/Scenarios", 
                itemIds: ['item-1', 'item-2', 'item-3', "item-4", "item-5", "item-6",
                    "item-7", "item-8", "item-9", "item-10"  ] },
            "column-2": { id: "column-2", title: "Automobile Insurance", itemIds: [] },
            "column-3": { id: "column-3", title: "Apartment/Home Insurance", itemIds: [] },
            "column-4": { id: "column-4", title: "Health Insurance", itemIds: [] },
            "column-5": { id: "column-5", title: "Not Covered By Your Insurance", itemIds: [] },
                  
        },
        columnOrder: ["column-1", "column-2", "column-3", "column-4", "column-5"]
    }

export default InsuranceChallenge1Dataset